import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { enumValues } from '@scale/shared/utils';
import { DisabledSBQReviewLevel } from '@scale/shared-types';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';

interface ReviewLevel {
  level?: string;
  value: boolean;
}

interface DisabledReturnToQueueReviewLevelsBuilderProps {
  name: string;
  existingValue?: DisabledSBQReviewLevel[];
  updateProperty: (arg: ReviewLevel) => void;
  required?: boolean;
  hint?: string;
}

const DisabledReturnToQueueReviewLevelsBuilder = ({
  existingValue = [],
  updateProperty,
  name,
  required,
  hint,
}: DisabledReturnToQueueReviewLevelsBuilderProps) => {
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row">
        <SelectMenu
          className="min-w-[135px]"
          options={enumValues(DisabledSBQReviewLevel).map(s => ({
            id: s,
            name: s,
          }))}
          selectedOptionId={existingValue as string[]}
          setSelected={val => {
            const newLevel = val.find(v => !existingValue.includes(v as DisabledSBQReviewLevel));
            const oldLevel = existingValue.find(v => !val.includes(v));
            const isAdding = val.length > existingValue.length;
            updateProperty({ level: isAdding ? newLevel : oldLevel, value: isAdding });
          }}
          multiple
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default DisabledReturnToQueueReviewLevelsBuilder;
